import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { Utils } from "arv-reactcomponents";

class ProductsScrolled extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      elemsScrolled: 0,
    };
  }

  triggerChange(containerRef) {
    const { noOfElements, elemsInRow } = this.props;
    if (!containerRef) {
      return;
    }

    const listVals = Utils.getBoundClientRect(containerRef);

    const totalRows = noOfElements / elemsInRow;

    const productHeight = listVals.height / totalRows;

    const windowHeight = window.innerHeight;
    const windowTop = Utils.windowScroll().top;

    const viewHeight = windowHeight + (windowTop - listVals.top);

    const elemsScrolled = Math.ceil(viewHeight / productHeight) * elemsInRow;

    if (elemsScrolled <= noOfElements) {
      this.setState({
        elemsScrolled,
      });
    } else {
      this.setState({
        elemsScrolled: noOfElements,
      });
    }
  }

  render() {
    const { className, totalElements } = this.props;
    const { elemsScrolled } = this.state;

    return (
      <div
        className={`nw-listingpage-productcount ${className} ${
          elemsScrolled > 0 ? "" : "nwc-hide"
        }`}
      >
        {`${elemsScrolled} / ${totalElements}`}
      </div>
    );
  }
}

ProductsScrolled.defaultProps = {
  className: "",
  noOfElements: 0,
  totalElements: null,
};

ProductsScrolled.propTypes = {
  className: PropTypes.string,
  noOfElements: PropTypes.number,
  totalElements: PropTypes.number,
  elemsInRow: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductsScrolled,
  component: ProductsScrolled,
};

export default ProjectComponent;
